/**
 * Using an accessible dialog or "modal" window. From Reach UI
 * https://ui.reach.tech/dialog
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import MediaQuery from 'react-responsive';

import { BREAKPOINT_SIZES, BREAKPOINTS } from 'tradera-constants/breakpoints';
import './dialog-modal.scss';

const mobileOnlyProps = { maxWidth: BREAKPOINT_SIZES[BREAKPOINTS.SM].max };
const desktopOnlyProps = { minWidth: BREAKPOINT_SIZES[BREAKPOINTS.MD].min };
const allDeviceProps = { minWidth: BREAKPOINT_SIZES[BREAKPOINTS.XS].min };

class DialogModal extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        desktop: PropTypes.bool,
        dismissOnOverlayClick: PropTypes.bool,
        mediaQueryProps: PropTypes.object,
        mobile: PropTypes.bool,
        mobileFullscreen: PropTypes.bool,
        onDismiss: PropTypes.func,
        style: PropTypes.object
    };

    static defaultProps = {
        className: '',
        desktop: false,
        dismissOnOverlayClick: true,
        mobile: false,
        mobileFullscreen: true
    };

    getDefaultMediaProps() {
        const { mobile, desktop } = this.props;
        if (mobile && desktop) {
            return allDeviceProps;
        }
        if (mobile) {
            return mobileOnlyProps;
        }
        if (desktop) {
            return desktopOnlyProps;
        }
        return allDeviceProps;
    }

    render() {
        const {
            children,
            className,
            dismissOnOverlayClick,
            onDismiss,
            mediaQuery,
            mobileFullscreen,
            style
        } = this.props;

        let mediaQueryProps;
        if (!mediaQuery) {
            mediaQueryProps = this.getDefaultMediaProps();
        } else {
            mediaQueryProps = mediaQuery;
        }

        return (
            <MediaQuery {...mediaQueryProps}>
                <DialogOverlay
                    onDismiss={dismissOnOverlayClick ? onDismiss : () => {}}
                    className={
                        'bp' +
                        (mobileFullscreen
                            ? ' mobile-fullscreen'
                            : ' mobile-alert')
                    }>
                    <DialogContent
                        className={className}
                        style={style}
                        role="dialog"
                        aria-modal={true}
                        aria-label="modal">
                        {children}
                    </DialogContent>
                </DialogOverlay>
            </MediaQuery>
        );
    }
}

export default DialogModal;
